import { authClient } from "@src/auth/client";
import { navigation } from "@src/navigation";
import { CreateAccountPage } from "@src/pages/CreateAccount";
import { useState } from "react";
import { useNavigate } from "react-router";
import type { ActionFunctionArgs, LoaderFunctionArgs } from "react-router-dom";

export function meta() {
  return [
    { title: "Create Account" },
    { name: "description", content: "Create a new account" },
  ];
}

export function clientLoader(_: LoaderFunctionArgs) {
  return {};
}

export async function clientAction(_args: ActionFunctionArgs) {
  return {};
}

export default function CreateAccountForClient() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  return (
    <CreateAccountPage
      onSubmit={async (values) => {
        try {
          const result = await authClient.signUp.email(
            {
              ...values,
              email: values.email,
              name: `${values.firstName} ${values.lastName}`,
              password: values.password,
              type: "physician",
            },
            {
              onSuccess: () => {
                navigate(navigation.dashboard(), { replace: true });
              },
            },
          );

          if (result.error) {
            setError(result.error.message ?? "An unknown error occurred");
          }
        } catch (error) {
          setError(
            error instanceof Error
              ? error.message
              : "An unexpected error occurred",
          );
        }
      }}
      error={error}
    />
  );
}
